import React from "react";
import { Sparkles } from "lucide-react";
import { useT } from "@/i18n";

export const DemoBanner = () => {
  const { t } = useT();
  return (
    <div
      data-testid="demo-banner"
      className="flex items-center gap-2.5 rounded-xl border border-amber-500/30 bg-amber-500/10 px-4 py-2.5 text-sm text-amber-700 dark:text-amber-300"
    >
      <Sparkles className="h-4 w-4 shrink-0" />
      <span>{t("common.demoBanner")}</span>
    </div>
  );
};
